// @flow
import React, { Fragment } from 'react';
import OpenStreetMap from 'components/fragments/map/OpenStreetMap';
import { MOBILE_SIZE } from 'constants/app';
import { dynamicClassName } from 'utils/dynamicClassName';
import { ffrName } from 'utils/ffrNameUtils';

type Props = {
  name: string,
  adress: {
    complement: string,
    street: string,
    postalCode: string,
    locality: string
  },
  lat: number,
  long: number,
  title?: string,
  hideIndicator?: bool,
};

const ClubAdress = (props: Props) => {
  let height;
  if (window.innerWidth < MOBILE_SIZE) {
    height = 456;
  } else {
    height = 268;
  }

  const wrapperClass = dynamicClassName('');
  !props.hideIndicator && wrapperClass.add('address mb-6 mb-md-7');

  return (
    <div className={wrapperClass.build()}>
      <a
        href={`https://www.google.com/maps/dir/?api=1&destination=${props.adress.street}+${props.adress.postalCode}+${props.adress.locality}`}
        title={ props.title ? props.title : "Visualiser l'adresse du club sur Google Maps (nouvel onglet)"}
        className="box card card--address "
        target="_blank"
        rel="noopener noreferrer"
        style={{zIndex: 50}}
        >
        <div className="card__body">
          <h3 className="card__title ft-h3">{ffrName(props.name)}</h3>
          <p className="card__desc">
            {props.adress.complement &&
              <Fragment>
                props.adress.complement
                <br />
              </Fragment>
            }
            {props.adress.street && 
              <Fragment>
                {props.adress.street},
                <br />
              </Fragment>
            }
            {props.adress.postalCode} {props.adress.locality}
          </p>
        </div>
        <div className="card__footer">
          <span className="link-chevron ">
            {"Voir l'itinéraire"}
            <i className="icon icon-chevron-right" />
          </span>
        </div>
      </a>
      <OpenStreetMap width="425" height={height} long={props.long} lat={props.lat} />
    </div>
  );
};

ClubAdress.defaultProps = {
  hideIndicator: false,
};

export default ClubAdress;
